import { render, staticRenderFns } from "./AllAssignedTerminals.vue?vue&type=template&id=2642871c&"
import script from "./AllAssignedTerminals.vue?vue&type=script&lang=js&"
export * from "./AllAssignedTerminals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports